"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

const IconColourModeSoundSync = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/_react.default.createElement("title", null, title) : null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.907 0a5.093 5.093 0 01.343 10.175V9l-.005-.16a2.328 2.328 0 00-.018-.17 3.593 3.593 0 10-3.339-1.627 2.27 2.27 0 00-.293.2l-.898.718A5.093 5.093 0 0118.907 0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 0c1.333 0 2.547.512 3.454 1.35-.37.34-.69.736-.945 1.173l-.032-.033a3.593 3.593 0 100 5.206l.032-.032c.059.101.122.2.188.297l-2.782 2.223-.13-.002A5.093 5.093 0 0112 0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.602 7.664c.256.437.575.832.945 1.173a5.093 5.093 0 11.001-7.487 5.06 5.06 0 00-.946 1.173l-.031-.033a3.593 3.593 0 100 5.206l.031-.032zm8.93.75l-4.796 3.836H8a.75.75 0 00-.75.75v6l.007.102A.75.75 0 008 19.75h3.737l4.795 3.836A.75.75 0 0017.75 23V9a.75.75 0 00-1.218-.586zm-.282 2.145V21.44l-3.781-3.026-.084-.058A.75.75 0 0012 18.25H8.75v-4.5H12a.75.75 0 00.469-.164l3.781-3.027zm4.76 1.371a.75.75 0 011.06 0 5.75 5.75 0 010 8.13.75.75 0 11-1.06-1.06 4.25 4.25 0 000-6.01.75.75 0 010-1.06z"
  }));
};

const ForwardRef = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(IconColourModeSoundSync, (0, _extends2.default)({
  svgRef: ref
}, props)));

var _default = ForwardRef;
exports.default = _default;